/** Where the signed-in owner's session stands, as far as this page knows. */
export var SessionState;
(function (SessionState) {
    SessionState["SIGNED_IN"] = "SIGNED_IN";
    /** "Sign out" was chosen; the page waits for the browser to leave for the login site. */
    SessionState["SIGNING_OUT"] = "SIGNING_OUT";
    /** An API answered "not signed in"; the page waits for the browser to leave for sign-in. */
    SessionState["ENDED"] = "ENDED";
})(SessionState || (SessionState = {}));
//# sourceMappingURL=SessionState.js.map